import "@/App.css";
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import TopBar from "@/components/site/TopBar";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/HomePage";
import ServicesIndexPage from "@/pages/ServicesIndexPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import FinancialOptionsPage from "@/pages/FinancialOptionsPage";
import ContactPage from "@/pages/ContactPage";
import FacialAestheticsPage from "@/pages/FacialAestheticsPage";
import AdminPage from "@/pages/AdminPage";
import LocalAreaPage from "@/pages/LocalAreaPage";
import BlogIndexPage from "@/pages/BlogIndexPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ExitIntentPopup from "@/components/site/ExitIntentPopup";

function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Give the target page a moment to render before scrolling
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - 110;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      };
      setTimeout(scroll, 60);
    } else {
      window.scrollTo({ top: 0 });
    }
  }, [pathname, hash]);
  return null;
}

function Layout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollToHash />
      {!isAdmin && <TopBar />}
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ExitIntentPopup />}
    </>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <LanguageProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesIndexPage />} />
              <Route path="/services/:slug" element={<ServiceDetailPage />} />
              <Route
                path="/facial-aesthetics"
                element={<FacialAestheticsPage />}
              />
              <Route
                path="/financial-options"
                element={<FinancialOptionsPage />}
              />
              <Route path="/contact" element={<ContactPage />} />
              <Route
                path="/dentist-in/:slug"
                element={<LocalAreaPage />}
              />
              <Route path="/insights" element={<BlogIndexPage />} />
              <Route path="/insights/:slug" element={<BlogPostPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="*" element={<HomePage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
